import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ServicesPage from "../pages/services/page";
import AboutPage from "../pages/about/page";
import LocationsPage from "../pages/locations/page";
import BaltimorePage from "../pages/locations/baltimore/page";
import AnnapolisPage from "../pages/locations/annapolis/page";
import ColumbiaPage from "../pages/locations/columbia/page";
import SilverSpringPage from "../pages/locations/silver-spring/page";
import RockvillePage from "../pages/locations/rockville/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/services", element: <ServicesPage /> },
  { path: "/about", element: <AboutPage /> },
  { path: "/locations", element: <LocationsPage /> },
  { path: "/locations/baltimore", element: <BaltimorePage /> },
  { path: "/locations/annapolis", element: <AnnapolisPage /> },
  { path: "/locations/columbia", element: <ColumbiaPage /> },
  { path: "/locations/silver-spring", element: <SilverSpringPage /> },
  { path: "/locations/rockville", element: <RockvillePage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;